/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum WindowsTimezone {
    DATELINE_STANDARD_TIME = 'DatelineStandardTime',
    UTC_MINUS11 = 'UtcMinus11',
    ALEUTIAN_STANDARD_TIME = 'AleutianStandardTime',
    HAWAIIAN_STANDARD_TIME = 'HawaiianStandardTime',
    MARQUESAS_STANDARD_TIME = 'MarquesasStandardTime',
    ALASKAN_STANDARD_TIME = 'AlaskanStandardTime',
    UTC_MINUS09 = 'UtcMinus09',
    PACIFIC_STANDARD_TIME_MEXICO = 'PacificStandardTimeMexico',
    UTC_MINUS08 = 'UtcMinus08',
    PACIFIC_STANDARD_TIME = 'PacificStandardTime',
    US_MOUNTAIN_STANDARD_TIME = 'UsMountainStandardTime',
    MOUNTAIN_STANDARD_TIME_MEXICO = 'MountainStandardTimeMexico',
    MOUNTAIN_STANDARD_TIME = 'MountainStandardTime',
    YUKON_STANDARD_TIME = 'YukonStandardTime',
    CENTRAL_AMERICA_STANDARD_TIME = 'CentralAmericaStandardTime',
    CENTRAL_STANDARD_TIME = 'CentralStandardTime',
    EASTER_ISLAND_STANDARD_TIME = 'EasterIslandStandardTime',
    CENTRAL_STANDARD_TIME_MEXICO = 'CentralStandardTimeMexico',
    CANADA_CENTRAL_STANDARD_TIME = 'CanadaCentralStandardTime',
    SA_PACIFIC_STANDARD_TIME = 'SaPacificStandardTime',
    EASTERN_STANDARD_TIME_MEXICO = 'EasternStandardTimeMexico',
    EASTERN_STANDARD_TIME = 'EasternStandardTime',
    HAITI_STANDARD_TIME = 'HaitiStandardTime',
    CUBA_STANDARD_TIME = 'CubaStandardTime',
    US_EASTERN_STANDARD_TIME = 'UsEasternStandardTime',
    TURKS_AND_CAICOS_STANDARD_TIME = 'TurksAndCaicosStandardTime',
    PARAGUAY_STANDARD_TIME = 'ParaguayStandardTime',
    ATLANTIC_STANDARD_TIME = 'AtlanticStandardTime',
    VENEZUELA_STANDARD_TIME = 'VenezuelaStandardTime',
    CENTRAL_BRAZILIAN_STANDARD_TIME = 'CentralBrazilianStandardTime',
    SA_WESTERN_STANDARD_TIME = 'SaWesternStandardTime',
    PACIFIC_SA_STANDARD_TIME = 'PacificSaStandardTime',
    NEWFOUNDLAND_STANDARD_TIME = 'NewfoundlandStandardTime',
    TOCANTINS_STANDARD_TIME = 'TocantinsStandardTime',
    E_SOUTH_AMERICA_STANDARD_TIME = 'ESouthAmericaStandardTime',
    SA_EASTERN_STANDARD_TIME = 'SaEasternStandardTime',
    ARGENTINA_STANDARD_TIME = 'ArgentinaStandardTime',
    GREENLAND_STANDARD_TIME = 'GreenlandStandardTime',
    MONTEVIDEO_STANDARD_TIME = 'MontevideoStandardTime',
    MAGALLANES_STANDARD_TIME = 'MagallanesStandardTime',
    SAINT_PIERRE_STANDARD_TIME = 'SaintPierreStandardTime',
    BAHIA_STANDARD_TIME = 'BahiaStandardTime',
    UTC_MINUS02 = 'UtcMinus02',
    AZORES_STANDARD_TIME = 'AzoresStandardTime',
    CAPE_VERDE_STANDARD_TIME = 'CapeVerdeStandardTime',
    UTC = 'Utc',
    GMT_STANDARD_TIME = 'GmtStandardTime',
    GREENWICH_STANDARD_TIME = 'GreenwichStandardTime',
    SAO_TOME_STANDARD_TIME = 'SaoTomeStandardTime',
    MOROCCO_STANDARD_TIME = 'MoroccoStandardTime',
    W_EUROPE_STANDARD_TIME = 'WEuropeStandardTime',
    CENTRAL_EUROPE_STANDARD_TIME = 'CentralEuropeStandardTime',
    ROMANCE_STANDARD_TIME = 'RomanceStandardTime',
    CENTRAL_EUROPEAN_STANDARD_TIME = 'CentralEuropeanStandardTime',
    W_CENTRAL_AFRICA_STANDARD_TIME = 'WCentralAfricaStandardTime',
    JORDAN_STANDARD_TIME = 'JordanStandardTime',
    GTB_STANDARD_TIME = 'GtbStandardTime',
    MIDDLE_EAST_STANDARD_TIME = 'MiddleEastStandardTime',
    EGYPT_STANDARD_TIME = 'EgyptStandardTime',
    E_EUROPE_STANDARD_TIME = 'EEuropeStandardTime',
    SYRIA_STANDARD_TIME = 'SyriaStandardTime',
    WEST_BANK_STANDARD_TIME = 'WestBankStandardTime',
    SOUTH_AFRICA_STANDARD_TIME = 'SouthAfricaStandardTime',
    FLE_STANDARD_TIME = 'FleStandardTime',
    ISRAEL_STANDARD_TIME = 'IsraelStandardTime',
    SOUTH_SUDAN_STANDARD_TIME = 'SouthSudanStandardTime',
    KALININGRAD_STANDARD_TIME = 'KaliningradStandardTime',
    SUDAN_STANDARD_TIME = 'SudanStandardTime',
    LIBYA_STANDARD_TIME = 'LibyaStandardTime',
    NAMIBIA_STANDARD_TIME = 'NamibiaStandardTime',
    ARABIC_STANDARD_TIME = 'ArabicStandardTime',
    TURKEY_STANDARD_TIME = 'TurkeyStandardTime',
    ARAB_STANDARD_TIME = 'ArabStandardTime',
    BELARUS_STANDARD_TIME = 'BelarusStandardTime',
    RUSSIAN_STANDARD_TIME = 'RussianStandardTime',
    E_AFRICA_STANDARD_TIME = 'EAfricaStandardTime',
    IRAN_STANDARD_TIME = 'IranStandardTime',
    ARABIAN_STANDARD_TIME = 'ArabianStandardTime',
    ASTRAKHAN_STANDARD_TIME = 'AstrakhanStandardTime',
    AZERBAIJAN_STANDARD_TIME = 'AzerbaijanStandardTime',
    RUSSIA_TIME_ZONE3 = 'RussiaTimeZone3',
    MAURITIUS_STANDARD_TIME = 'MauritiusStandardTime',
    SARATOV_STANDARD_TIME = 'SaratovStandardTime',
    GEORGIAN_STANDARD_TIME = 'GeorgianStandardTime',
    VOLGOGRAD_STANDARD_TIME = 'VolgogradStandardTime',
    CAUCASUS_STANDARD_TIME = 'CaucasusStandardTime',
    AFGHANISTAN_STANDARD_TIME = 'AfghanistanStandardTime',
    WEST_ASIA_STANDARD_TIME = 'WestAsiaStandardTime',
    EKATERINBURG_STANDARD_TIME = 'EkaterinburgStandardTime',
    PAKISTAN_STANDARD_TIME = 'PakistanStandardTime',
    QYZYLORDA_STANDARD_TIME = 'QyzylordaStandardTime',
    INDIA_STANDARD_TIME = 'IndiaStandardTime',
    SRI_LANKA_STANDARD_TIME = 'SriLankaStandardTime',
    NEPAL_STANDARD_TIME = 'NepalStandardTime',
    CENTRAL_ASIA_STANDARD_TIME = 'CentralAsiaStandardTime',
    BANGLADESH_STANDARD_TIME = 'BangladeshStandardTime',
    OMSK_STANDARD_TIME = 'OmskStandardTime',
    MYANMAR_STANDARD_TIME = 'MyanmarStandardTime',
    SE_ASIA_STANDARD_TIME = 'SeAsiaStandardTime',
    ALTAI_STANDARD_TIME = 'AltaiStandardTime',
    W_MONGOLIA_STANDARD_TIME = 'WMongoliaStandardTime',
    NORTH_ASIA_STANDARD_TIME = 'NorthAsiaStandardTime',
    N_CENTRAL_ASIA_STANDARD_TIME = 'NCentralAsiaStandardTime',
    TOMSK_STANDARD_TIME = 'TomskStandardTime',
    CHINA_STANDARD_TIME = 'ChinaStandardTime',
    NORTH_ASIA_EAST_STANDARD_TIME = 'NorthAsiaEastStandardTime',
    SINGAPORE_STANDARD_TIME = 'SingaporeStandardTime',
    W_AUSTRALIA_STANDARD_TIME = 'WAustraliaStandardTime',
    TAIPEI_STANDARD_TIME = 'TaipeiStandardTime',
    ULAANBAATAR_STANDARD_TIME = 'UlaanbaatarStandardTime',
    AUS_CENTRAL_W_STANDARD_TIME = 'AusCentralWStandardTime',
    TRANSBAIKAL_STANDARD_TIME = 'TransbaikalStandardTime',
    TOKYO_STANDARD_TIME = 'TokyoStandardTime',
    NORTH_KOREA_STANDARD_TIME = 'NorthKoreaStandardTime',
    KOREA_STANDARD_TIME = 'KoreaStandardTime',
    YAKUTSK_STANDARD_TIME = 'YakutskStandardTime',
    CEN_AUSTRALIA_STANDARD_TIME = 'CenAustraliaStandardTime',
    AUS_CENTRAL_STANDARD_TIME = 'AusCentralStandardTime',
    E_AUSTRALIA_STANDARD_TIME = 'EAustraliaStandardTime',
    AUS_EASTERN_STANDARD_TIME = 'AusEasternStandardTime',
    WEST_PACIFIC_STANDARD_TIME = 'WestPacificStandardTime',
    TASMANIA_STANDARD_TIME = 'TasmaniaStandardTime',
    VLADIVOSTOK_STANDARD_TIME = 'VladivostokStandardTime',
    LORD_HOWE_STANDARD_TIME = 'LordHoweStandardTime',
    BOUGAINVILLE_STANDARD_TIME = 'BougainvilleStandardTime',
    RUSSIA_TIME_ZONE10 = 'RussiaTimeZone10',
    MAGADAN_STANDARD_TIME = 'MagadanStandardTime',
    NORFOLK_STANDARD_TIME = 'NorfolkStandardTime',
    SAKHALIN_STANDARD_TIME = 'SakhalinStandardTime',
    CENTRAL_PACIFIC_STANDARD_TIME = 'CentralPacificStandardTime',
    RUSSIA_TIME_ZONE11 = 'RussiaTimeZone11',
    NEW_ZEALAND_STANDARD_TIME = 'NewZealandStandardTime',
    UTC_PLUS12 = 'UtcPlus12',
    FIJI_STANDARD_TIME = 'FijiStandardTime',
    CHATHAM_ISLANDS_STANDARD_TIME = 'ChathamIslandsStandardTime',
    UTC_PLUS13 = 'UtcPlus13',
    TONGA_STANDARD_TIME = 'TongaStandardTime',
    SAMOA_STANDARD_TIME = 'SamoaStandardTime',
    LINE_ISLANDS_STANDARD_TIME = 'LineIslandsStandardTime'
}


export function instanceOfWindowsTimezone(value: any): boolean {
    for (const key in WindowsTimezone) {
        if (Object.prototype.hasOwnProperty.call(WindowsTimezone, key)) {
            if (WindowsTimezone[key as keyof typeof WindowsTimezone] === value) {
                return true;
            }
        }
    }
    return false;
}

export function WindowsTimezoneFromJSON(json: any): WindowsTimezone {
    return WindowsTimezoneFromJSONTyped(json, false);
}

export function WindowsTimezoneFromJSONTyped(json: any, ignoreDiscriminator: boolean): WindowsTimezone {
    return json as WindowsTimezone;
}

export function WindowsTimezoneToJSON(value?: WindowsTimezone | null): any {
    return value as any;
}

export function WindowsTimezoneToJSONTyped(value: any, ignoreDiscriminator: boolean): WindowsTimezone {
    return value as WindowsTimezone;
}

